import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "./motion";

export const ArchitectureMatrix = () => {
  return (
    <section data-testid="architecture-matrix-section" className="border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 lg:pt-28 pb-10 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <div>
          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="text-[10px] tracking-[0.35em] uppercase text-zinc-500 mb-6"
          >
            Interactive / Environment Mapping
          </motion.p>
          <motion.h2
            variants={fadeUp}
            custom={1}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="font-display text-2xl sm:text-3xl lg:text-4xl uppercase tracking-tight font-bold text-white max-w-2xl"
          >
            Live Architecture Matrix
          </motion.h2>
        </div>
        <motion.p
          variants={fadeUp}
          custom={2}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="text-xs text-zinc-500 max-w-sm leading-relaxed"
        >
          A real-time operations render of an active enclosure compound. Select any
          structure to extract its engineering parameters; toggle layers from the
          control stack.
        </motion.p>
      </div>

      <motion.div
        variants={fadeUp}
        custom={2}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="border-t border-zinc-800 h-[85vh]"
      >
        <iframe
          data-testid="architecture-matrix-frame"
          src="/equinox-matrix.html"
          sandbox="allow-scripts allow-same-origin"
          title="Project Equinox Architecture Dashboard — interactive canvas environment map"
          className="w-full h-full border-0 block"
        />
      </motion.div>
    </section>
  );
};
